import { useState } from "react";
import { Expand } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
export const productPhotos = (p) => (p.images?.length ? p.images : p.image ? [p.image] : []).map(fileUrl);

export function ProductGallery({ product }) {
  const photos = productPhotos(product);
  const [idx, setIdx] = useState(0);
  const [open, setOpen] = useState(false);
  if (!photos.length) return null;
  const cur = photos[Math.min(idx, photos.length - 1)];
  return (
    <div className="flex gap-3 items-start" data-testid="product-gallery">
      <button data-testid="product-gallery-main" onClick={() => setOpen(true)} className="group relative w-40 h-40 sm:w-44 sm:h-44 shrink-0 rounded-lg border border-slate-200 bg-white overflow-hidden">
        <img src={cur} alt={product.name} className="w-full h-full object-contain p-1.5" />
        <span className="absolute bottom-1.5 right-1.5 w-7 h-7 rounded-full bg-white/90 border flex items-center justify-center opacity-80 group-hover:opacity-100"><Expand className="w-3.5 h-3.5" /></span>
      </button>
      {photos.length > 1 && (
        <div className="grid grid-cols-3 gap-1.5">
          {photos.map((u, i) => (
            <button key={u} data-testid={`product-gallery-thumb-${i}`} onClick={() => setIdx(i)}
              className={`w-11 h-11 rounded-md border overflow-hidden bg-white ${i === idx ? "border-brand-navy ring-2 ring-brand-yellow" : "border-slate-200"}`}>
              <img src={u} alt="" className="w-full h-full object-contain" />
            </button>
          ))}
        </div>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl" data-testid="product-gallery-dialog">
          <DialogHeader><DialogTitle>{product.name}</DialogTitle></DialogHeader>
          <img src={cur} alt={product.name} className="w-full max-h-[70vh] object-contain" />
          {photos.length > 1 && (
            <div className="flex gap-2 justify-center">
              {photos.map((u, i) => (
                <button key={u} onClick={() => setIdx(i)} className={`w-14 h-14 rounded border overflow-hidden ${i === idx ? "border-brand-navy ring-2 ring-brand-yellow" : ""}`}><img src={u} alt="" className="w-full h-full object-contain" /></button>
              ))}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
